"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUUID = isUUID;
const uuid_1 = require("uuid");
const uuid_2 = require("uuid");
function isUUID(uuid) {
  let version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  return (0, uuid_2.validate)(uuid) && (0, uuid_1.version)(uuid) === version;
}